<template>
  <!-- 精细化雨量评估 -->
  <div class="content">
    <div class="hour-forecast">
      <div class="hour-forecast-wrap">
        <div class="hour-forecast-list" ref="hourForecastList">
          <div id="refined-rainfall"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import echarts from "@/config/echarts/index.js";
import { getHourForecastOption } from "@/config/echarts/option/refined-rainfall.js";
import { mapState } from "vuex";
export default {
  props: ["params", "forecastType", "cardEchart"],
  data() {
    return {
      charts: "",
      giftData: {},
      timmer: null,
    };
  },
  watch: {
    activeCountyId: {
      handler() {
        setTimeout(() => {
          this.$nextTick(() => {
            this.getGiftData();
          });
        }, 100);
      },
      immediate: true,
    },
    forecastType() {
      this.resetEchart();
    },
    refinedRainDataResult: {
      handler() {
        this.$nextTick(() => {
          this.getGiftData();
        });
      },
      deep: true,
    },
  },
  computed: {
    ...mapState("home", [
      "objsList",
      "activeCountyId",
      "slideLiveResult",
      "refinedRainDataResult",
    ]),
  },
  methods: {
    initEchart() {
      // 24小时预报温度曲线图
      const idName = "refined-rainfall";
      const tempChart = echarts.init(document.getElementById(idName));
      tempChart.setOption(getHourForecastOption());
      this.charts = tempChart;

      // 页面缩放
      window.onresize = () => {
        Vue.prototype.$rootFontSize = (document.body.clientWidth / 1920) * 16;
        document.getElementsByTagName("html")[0].style.fontSize =
          this.$rootFontSize + "px";
        this.charts.resize();
      };

      this.$bus.$on("changeLiveForestResize", () => {
        this.$nextTick(() => {
          this.charts.resize();
        });
      });

      this.$bus.$on("changeCardData", () => {
        this.$nextTick(() => {
          this.charts.resize();
        });
      });
    },
    // 获取gif预报
    async getGiftData() {
      const index = this.objsList.findIndex(
        (item) => item.id === this.activeCountyId,
      );
      const lon = (Math.round(this.objsList[index].lon / 0.05) * 0.05)
        .toFixed(2)
        .replace(/\./g, "");

      console.log("lon", lon);

      if (!this.charts) {
        this.initEchart();
      }

      const result = this.refinedRainDataResult;
      console.log("result", result);
      const times = result.times_r6m.map((item) =>
        this.$moment(item).format("HH:mm"),
      );
      const currentTime = new Date();
      const filteredTimes = times.filter((timeStr) => {
        const time = this.$moment(timeStr, "HH:mm");
        return time.isAfter(currentTime, "minute"); // 确保比较到分钟级别
      });
      const startIndex = times.indexOf(filteredTimes[0]);
      const data = result.datas[lon].r6mlev;
      const echartData = data.slice(startIndex);
      console.log("filteredTimes", filteredTimes);
      console.log("echartData", echartData);

      const option1 = getHourForecastOption();
      option1.series[0].data = echartData;
      option1.xAxis.data = filteredTimes;
      option1.yAxis.axisLabel = {
        color: "#FFF",
        fontSize: "0.9rem",
        formatter: function (value) {
          const map = { 0: "", 1: "小雨", 2: "中雨", 3: "大雨", 4: "暴雨" };
          return map[value] || "";
        },
      };
      option1.yAxis.max = 4;
      option1.yAxis.min = 0;
      this.charts.clear();
      this.charts.setOption(option1);
      this.$nextTick(() => {
        this.charts.resize();
      });
    },

    resetEchart() {
      this.$nextTick(() => {
        this.charts && this.charts.resize();
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  padding: 2.6vw 1.04vw 0.56vw;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  border-radius: 0.63vw;
  // pointer-events: none;

  .hour-forecast {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 0vw;

    .hour-forecast-wrap {
      position: relative;
      // top: -2.04vw;
      width: 100%;
      margin-top: 0.52vw;
      height: calc(100% - 0.52vw);
      overflow: hidden;

      .hour-forecast-list {
        width: 100% !important;
        display: flex;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        transition: all 0.3s linear;

        .item {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          width: 5.58rem;

          span {
            font-size: 0.75rem;
            color: #fff;
          }

          .des {
            font-size: 0.88rem;
            color: #fff;
          }

          img {
            width: 2.25rem;
          }

          .chart {
            height: 90%;
          }

          .wind {
            color: #fff;
          }
        }

        #refined-rainfall {
          position: absolute;
          left: 0;
          top: 0;
          height: 100%;
          width: 100%;
        }
      }
    }

    .left-botton {
      width: 0.81rem;
      height: 1.88rem;
      background: url("../../../assets/images/左.png") no-repeat;
      background-size: contain;
      position: absolute;
      top: 50%;
      margin-top: -0.94rem;
      left: 1.2rem;
      cursor: pointer;
    }

    .right-botton {
      width: 0.81rem;
      height: 1.88rem;
      background: url("../../../assets/images/右.png") no-repeat;
      background-size: contain;
      position: absolute;
      top: 50%;
      margin-top: -0.94rem;
      right: 1.2rem;
      cursor: pointer;
    }
  }

  .days-forecast {
    height: 100%;
    // padding: 8% 3% 0 2%;
    box-sizing: border-box;

    .days-forecast-list {
      display: flex;
      justify-content: space-between;
      height: 100%;
      position: relative;

      .item {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        width: 6.85rem;

        span {
          font-size: 0.75rem;
          color: #fff;
        }

        font {
          font-size: 0.88rem;
          color: #fff;
        }

        img {
          width: 2rem;
        }

        .chart {
          height: 50%;
        }
      }

      #high-low-temp-chart {
        position: absolute;
        left: 2.3rem;
        right: 2.3rem;
        top: 52%;
        height: 45%;
      }
    }
  }

  .publish-time {
    display: flex;
    align-items: center;
    position: absolute;
    right: 2.08vw;
    top: 0.8vw;
    color: #fff;
    font-size: 0.63vw;

    .el-icon-time {
      margin-right: 0.26vw;
    }
  }
}
</style>
